import * as R from 'remeda';
import { getIDFromUrl } from '@rossum/api-client';
import { ApplyLabelPayload } from '@rossum/api-client/labels';

type ApplyLabelsToAnnotationsMeta = { labelsInQuery: Array<string> };

export const handleLabelsUpdate = <T extends { url: string; labels: string[] }>(
  list: Array<T>,
  payload: ApplyLabelPayload,
  meta: ApplyLabelsToAnnotationsMeta
) => {
  const updatedList = list.map(annotation =>
    payload.objects.annotations.includes(annotation.url)
      ? {
          ...annotation,
          labels: R.sortBy(
            annotation.labels
              .filter(
                label => !(payload.operations.remove ?? []).includes(label)
              )
              .concat(payload.operations.add ?? []),
            R.identity
          ),
        }
      : annotation
  );

  return meta.labelsInQuery.length
    ? updatedList.filter(annotation =>
        annotation.labels.some(label =>
          meta.labelsInQuery.includes(`${getIDFromUrl(label)}`)
        )
      )
    : updatedList;
};
